// PROMPT 141: urgencia de la Bandeja por la FECHA DEL TOUR que dice el correo, no por cuándo llegó.
// "lo ideal seria que se pueda organizar por prioridad en el contenido del correo mas no prioridad
// en la fecha que llegue" (operaciones). "Hoy" es el de Nueva York, igual que en el servidor.

const RE_FECHA = /^\d{4}-\d{2}-\d{2}$/;

export function hoyNY() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
}

function diasHasta(hoy, fecha) {
  const [a1, m1, d1] = hoy.split("-").map(Number);
  const [a2, m2, d2] = fecha.split("-").map(Number);
  return Math.round((Date.UTC(a2, m2 - 1, d2) - Date.UTC(a1, m1 - 1, d1)) / 86400000);
}

// Nivel 1 = lo más urgente. `cls` son las clases de la etiqueta.
export function urgencia(fecha, hoy = hoyNY()) {
  if (!fecha || !RE_FECHA.test(fecha)) {
    return { nivel: 5, texto: "Sin fecha del tour", cls: "bg-slate-50 text-slate-500 border-slate-200" };
  }
  const dias = diasHasta(hoy, fecha);
  if (dias < 0) return { nivel: 6, texto: "El tour ya pasó", cls: "bg-slate-50 text-slate-400 border-slate-200" };
  if (dias === 0) return { nivel: 1, texto: "Urgente · hoy", cls: "bg-red-50 text-red-700 border-red-300" };
  if (dias === 1) return { nivel: 1, texto: "Urgente · mañana", cls: "bg-red-50 text-red-700 border-red-300" };
  if (dias <= 3) return { nivel: 2, texto: `Pronto · en ${dias} días`, cls: "bg-orange-50 text-orange-700 border-orange-200" };
  if (dias <= 7) return { nivel: 3, texto: `Esta semana · en ${dias} días`, cls: "bg-amber-50 text-amber-700 border-amber-200" };
  return { nivel: 4, texto: `Más adelante · en ${dias} días`, cls: "bg-sky-50 text-sky-700 border-sky-200" };
}

// Primero el tour de hoy en adelante (el más cercano arriba), después los que no tienen fecha y al
// final los de tours que ya pasaron (el más reciente arriba). En un empate queda el orden que traían.
export function ordenarPorUrgencia(items, fechaDe, hoy = hoyNY()) {
  const grupo = (f) => (!f || !RE_FECHA.test(f) ? 1 : f >= hoy ? 0 : 2);
  return items
    .map((x, i) => ({ x, i, f: fechaDe(x) }))
    .sort((a, b) => {
      const ga = grupo(a.f);
      const gb = grupo(b.f);
      if (ga !== gb) return ga - gb;
      if (ga === 0 && a.f !== b.f) return a.f < b.f ? -1 : 1;
      if (ga === 2 && a.f !== b.f) return a.f > b.f ? -1 : 1;
      return a.i - b.i;
    })
    .map((o) => o.x);
}
